import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import s from './InputLabel.scss';
/**
 * Renders children in a `<label />`. This is a necessary element of all form elements.
 */ const InputLabel = (_param)=>{
    var { children , className  } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", _extends({
        className: classnames(s['root'], className)
    }, rest), children);
};
InputLabel.displayName = 'InputLabel';
export default InputLabel;
